import * as React from "react";
const SVGComponent = ({ color = "#1D1D1D", ...props }) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={10.3335}
      cy={10}
      r={9}
      fill="white"
      stroke={color}
      strokeWidth={2}
    />
  </svg>
);
export default SVGComponent;